export default __webpack_public_path__ + "static/media/arrow-text-left.35bcf4cc.svg";